//配置全局访问接口地址
let commonUrl = "http://tz.zgsg.mo.cn";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl